import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BasicLayout } from '../../shared/layout';
import { ConfirmationTemplate } from '../../modules/users/components';
import { useAppDispatch, useAppSelector } from '../../shared/infra/redux';
import { verifyUserEmailToken } from '../../modules/users/redux/operators';
import { LoadingModal } from '../../shared/components/loader';

type VerificationParams = {
  token?: string;
};

function EmailVerificationPage(): JSX.Element {
  const dispatch = useAppDispatch();
  const isVerified = useAppSelector((state) => state.public.isEmailVerified);

  const params = useParams<VerificationParams>();
  const { token } = params;

  const handleOnVerifyEmailToken = useCallback(
    async (token?: string) => {
      await dispatch(verifyUserEmailToken({ token }));
    },
    [dispatch],
  );

  useEffect(() => {
    void handleOnVerifyEmailToken(token);
  }, [handleOnVerifyEmailToken, token]);

  return (
    <BasicLayout>
      {isVerified === undefined && <LoadingModal isLoading={true} />}

      <div className='mx-auto flex w-2/3 flex-1 items-center justify-center lg:w-1/2 xl:w-1/3'>
        {isVerified && (
          <ConfirmationTemplate
            title='Your Email Has Been Verified'
            subtitle='Thank you! You can now access your account'
          />
        )}

        {!isVerified && (
          <ConfirmationTemplate
            isError={true}
            title='Error Trying To Verify User'
            subtitle='Verification Token does not exist or has expired'
          />
        )}
      </div>
    </BasicLayout>
  );
}

export default EmailVerificationPage;
